import { Review, reviewFromResponse } from '../Review/Review';

export interface ProductReview {
  reviews: Review[];
  totalCount: number;
  avgRating: number;
}

export const productReviewFromResponse = (
  responseData: any,
): ProductReview => ({
  reviews: responseData.reviews.map(reviewFromResponse),
  totalCount: responseData.total_count,
  avgRating: responseData.avg_rating,
});
